import axios, { AxiosRequestConfig } from 'axios';
import { LoginCredentials } from './types';
import { getErrorMessage } from '../../../../globalFunctions';

export const getMoodleServers = async () => {
    try {
        const requestConfig: AxiosRequestConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Accept: 'application/json'
            }
        };

        const response = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/api/moodle/servers`,
            requestConfig
        );

        return response.data;
    } catch (error) {
        const response = {
            message: 'Erro ao buscar instituições',
            error: error
        };

        console.error(response);

        return response;
    }
};

export const authenticate = async (credentials: LoginCredentials) => {
    try {
        const requestConfig: AxiosRequestConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Accept: 'application/json'
            }
        };

        // csrf-cookie
        await axios.get(`${process.env.REACT_APP_BACKEND_URL}/sanctum/csrf-cookie`);
        const response = await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/api/auth/authenticate`,
            credentials,
            requestConfig
        );

        return response.data.user;
    } catch (error: any) {
        const response = {
            message: getErrorMessage(error.response.data.error),
            error: error
        };

        console.error(response);

        return response;
    }
};
